const ANNOUNCEMENT_TYPE = [
    { value: 'ScholarshipGrant', label: 'Concessão de bolsa de estudo' },
    { value: 'PeriodicVerification', label: 'Aferição periódica (manutenção)' },
];

export default ANNOUNCEMENT_TYPE